import { uploadImageFile } from '@eventbrite/http';

const noop = () => {
    // no-op
};

export const uploadImageFromUrl = async (imageUrl: string) => {
    /*const cropMask = {
        crop_mask: {
            width: IMAGE_WIDTH,
            height: IMAGE_HEIGHT,
            top_left: {
                y: 0,
                x: 0,
            },
        },
    };*/

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const type = response.headers.get('content-type') || '';
    const file = new File([blob], 'img', { type });

    return uploadImageFile(file, 'image-event-logo', noop);
};
